<template>
    <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                    <div class="col-8">
                        <h3 class="mb-0">Nachweis editieren</h3>
                    </div>
                    <div class="col-4 text-right">
                        <base-button size="sm" @click.prevent="downloadFileAndShowDocumentViewer(fileData.replace( /^\D+/g, ''))" icon="fas fa-search" alt="Dokument anschauen" ></base-button>
                    </div>
                </div>
            </div>
            <template>

                <form @submit.prevent="editPD($route.params.id)">
                    <base-alert v-if="status.type !== ''" :type="status.type">{{ status.msg }}</base-alert>

                    <profile-document-form :edit="true" :loading-prop="isLoading" ref="PDForm"></profile-document-form>
                    <!-- Address -->
                    <button class="btn btn-icon my-4 btn-primary" :disabled="isLoading">
                        <span :key="tick" class="btn-inner--icon"><i v-if="isLoading" class="fas fa-circle-notch fa-spin"></i><i v-else class="ni ni-fat-add"></i></span>
                        <span class="btn-inner--text">Nachweis ändern</span></button>
                </form>
            </template>
        </card>
</template>

<script>
    import ProfileDocumentForm from "@/views/ProfileDocuments/profiledocumentform";

    export default {
        name: "edit",
        components:{ProfileDocumentForm},
        data() {
            return {
                isLoading: false,
                tick: 1,
                ready: false,
                documentUrl: '',
                documentType: '',
                status: {
                    type: '',
                    msg: ''
                }
            }
        },
        mounted() {
            this.showPD(this.$route.params.id)
        },
        computed: {
            fileData() {
                return (this.ready) ? this.$refs.PDForm.profileDocument.document : null
            }
        },
        methods: {
            setLoading(val) {
                this.isLoading = val;
                this.tick++;
            },
            showPD(id) {
                return new Promise(() => {
                    this.setLoading(true);
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header,
                    };
                    this.isLoading = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/profile_documents/`+id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                this.$refs.PDForm.profileDocument = response;
                                this.$refs.PDForm.profileDocument.profile = (response.profile) ? response.profile['@id'] : null;
                                this.$refs.PDForm.profileDocument.customer = (response.customer) ? response.customer['@id'] : null;
                                this.$refs.PDForm.profileDocument.user = (response.user) ? response.user['@id'] : null;
                                this.$refs.PDForm.profileDocument.document = (response.document) ? response.document['@id'] : null;
                                this.ready = true;
                                this.setLoading(false);
                            },
                            error => {
                                this.setLoading(false);
                                this.status =  {type: 'danger', msg: error};
                            });
                });
            },
            editPD(id) {
                return new Promise(() => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/merge-patch+json';
                    let senddata = this.$refs.PDForm.profileDocument;
                    const requestOptions = {
                        method: 'PATCH',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    this.isLoading = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/profile_documents/`+id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                this.setLoading(false);
                                this.status =  {type: 'success', msg: 'Nachweis '+response.name+' (ID: '+response.id+') wurde editiert.'};
                            },
                            error => {
                                this.setLoading(false);
                                this.status =  {type: 'danger', msg: error};
                            });
                });
            },
        }
    }
</script>

<style scoped>

</style>